// Core
import React from 'react';
import { useHistory } from 'react-router-dom';

// Custom Components
import IntroPage from '../../../../pages/IntroPage';

// Custom Modules
import { textsNoShop } from '../../../../texts';

const Intro = ({ details, setDetailsValueByKey }) => {
    let history = useHistory();

    const onClick = () => {
        history.push('/noShop/q1');
    };

    return (
        <IntroPage
            intro={textsNoShop.intro}
            onClick={onClick}
            onChange={setDetailsValueByKey}
            details={details}
        />
    );
};

export default Intro;